export default "__VITE_ASSET__62b82223__"